module.exports = __webpack_public_path__ + "img/vip_gold_d_dark.2e717250.svg";